import { render, staticRenderFns } from "./QualityControlAuditTrailHistory.vue?vue&type=template&id=78f540c3"
import script from "./QualityControlAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./QualityControlAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports